import React from 'react';
import Container from '../../components/UI/Container/Container';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { getUser } from '../../redux/selectors';
import { connect } from 'react-redux';
import Headline from '../../components/UI/Headline/Headline';
import OrdersTable from './OrdersTable';
import UserInfo from './UserInfo';
import { updateLanguage } from '../../http/user';

const Profile = ({ user, language, changeUserLanguage }) => {
  const { t } = useTranslation();

  return (
    <Container style={{ marginTop: 160 }}>
      <div>
        <Headline>{t('pages.profile.title')}</Headline>
        <UserInfo user={user} changeUserLanguage={changeUserLanguage} />
      </div>

      <div style={{ marginTop: 100 }}>
        <Space direction='vertical' size='large'>
          <div>
            <Headline>{t('pages.orders.title')}</Headline>
          </div>
          <OrdersTable language={language} />
        </Space>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: getUser(state),
  language: state.app.language
});

const mapDispatchToProps = (dispatch) => ({
  changeUserLanguage: (language) => dispatch(updateLanguage(language))
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
